<template>
    <swiper
        :slides-per-view="1"
        effect="fade"
        :autoplay="autoPlayOptions"
        :modules="[EffectFade, Autoplay]"
        :loop="true"
        @swiper="onSwiper">
        <swiper-slide v-for="(ad, index) in ads" :key="`slide-${index}`">
            <!-- TODO: 
            - Picture tag
            - Container queries? -->
            <a
                class="advertisement"
                :href="ad.Link.Url"
                :title="ad.Link.Text"
                :target="ad.Link.Target">
                <figure class="advertisement__figure">
                    <img :src="ad.Image.ImageUrl" :alt="ad.Image.AlternativeText" loading="lazy" />
                </figure>
            </a>
        </swiper-slide>
    </swiper>
</template>

<script lang="ts">
import { IAd } from './interface/advertisement.model';
import { defineComponent, PropType } from 'vue';
import { Autoplay } from 'swiper';
import { EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { AutoplayOptions } from 'swiper/types';

export default defineComponent({
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        ads: {
            type: Array as PropType<Array<IAd>>, //https://forum.vuejs.org/t/specifying-array-type-of-prop-in-vue-3-0-with-typescript/103169
            required: true,
        },
    },
    setup() {
        const onSwiper = (swiper: any) => {
            setTimeout(() => {
                swiper.autoplay.start();
            }, 300);
        };
        const autoPlayOptions: AutoplayOptions = {
            delay: 3000,
            pauseOnMouseEnter: false,
            disableOnInteraction: false,
        };
        return {
            autoPlayOptions,
            Autoplay,
            EffectFade,
            onSwiper,
        };
    },
});
</script>
